export const FULL_DAY = 'CONSTANT.FULL_DAY'
